import { provideState } from '@ngrx/store';
import { EnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { deviceCommentsFeature } from './+state/reducers/device-comments.reducer';
import { DevicesEffects } from './+state/effects/devices.effects';
import { DeviceCommentsEffects } from './+state/effects/device-comments.effects';
import { devicesFeature } from './+state/reducers/devices.reducer';
import { deviceCallLogsFeature } from './+state/reducers/device-call-logs.reducer';
import { DeviceCallLogsEffects } from './+state/effects/device-call-logs.effects';
import { deviceVariablesFeature } from './+state/reducers/device-variables.reducer';
import { DeviceVariablesEffects } from './+state/effects/device-variables.effects';

export function provideDevicesState(): EnvironmentProviders[] {
  return [provideState(devicesFeature.name, devicesFeature.reducer), provideEffects([DevicesEffects])];
}

export function provideDeviceCommentsState(): EnvironmentProviders[] {
  return [provideState(deviceCommentsFeature.name, deviceCommentsFeature.reducer), provideEffects([DeviceCommentsEffects])];
}

export function provideDeviceVariablesState(): EnvironmentProviders[] {
  return [provideState(deviceVariablesFeature.name, deviceVariablesFeature.reducer), provideEffects([DeviceVariablesEffects])];
}

export function provideDeviceCallLogsState(): EnvironmentProviders[] {
  return [provideState(deviceCallLogsFeature.name, deviceCallLogsFeature.reducer), provideEffects([DeviceCallLogsEffects])];
}
